import cn from 'classnames';

interface DividerProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

/**
 * A reusable divider component that renders a horizontal dashed line.
 */
const Divider: React.FC<DividerProps> = ({ className, ...otherProps }) => (
  <span
    className={cn(
      'border-other-divider my-3 block h-px w-full border-b border-dashed',
      className
    )}
    data-test="divider"
    {...otherProps}
  />
);

export default Divider;
